export default __webpack_public_path__ + "static/favicon-9820a612978b1936914e68b57d436203.ico";